module.exports = __webpack_public_path__ + "static/media/bg_batalha.521db752.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg/bg_batalha.png
// module id = 456
// module chunks = 0